import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ObjectUtil } from '@core/utils';

@Component({
  standalone: true,
  template: '',
})
export abstract class DefferedDialogComponent<TResult, TData = TResult, TModel = TResult> implements OnInit {
  readonly dialogRef = inject(MatDialogRef);
  readonly form = new FormGroup([]);
  protected _data = ObjectUtil.deepClone(inject(MAT_DIALOG_DATA) || {}) as TData;
  get dialogData() {
    return this._data;
  }
  model = {} as TModel;

  @Output() closeForm = new EventEmitter <{ confirmed: boolean; value?: TResult; close: () => void }> ();

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  protected submitFormData(value: TResult) {
    this.closeForm.emit({ confirmed: true, value, close: () => this.dialogRef.close() });
  }

  protected cancel() {
    this.closeForm.emit({ confirmed: false, close: () => this.dialogRef.close() });
    this.dialogRef.close();
  }
}
